module.exports = __webpack_public_path__ + "img/tema-1-11.f9f7d502.svg";